module.exports = __webpack_public_path__ + "assets/img/ON.6a76d261.svg";